import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe} from '@angular/common';
export class ServicesClockIn{
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
    console.log("门店信息");
    if(webcontext.ConfigType.toLowerCase()=="form"){
        let request = JSON.parse(webcontext.RequestBody);
        webcontext.OpType = "Edite";
    // if(typeof(request["a_StartAddress"])=="undefined" && (typeof(request.a_StartRemark)=="undefined" || request.a_StartRemark.toString().trim()=="")){
    //       webcontext.ResponseMessage.ErrorMessage = "请填写备注说明";
    //       webcontext.ResponseMessage.Success = false;
    //   }else if(!request.a_StartAddress &&  (typeof(request.a_StartRemark)=="undefined" || request.a_StartRemark.toString().trim()=="")){
    //     webcontext.ResponseMessage.ErrorMessage = "请填写备注说明";
    //     webcontext.ResponseMessage.Success = false;
    //   }
      if(request.a_StartRemark && webcontext.ResponseMessage.Success){//如果填写备注则必须拍摄门头照
        if(typeof(request["a_StartPhoto"])=="undefined"){
          webcontext.ResponseMessage.Success =false;
          webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
        }else if(request.a_StartPhoto.toString().trim() == ""){
          webcontext.ResponseMessage.Success =false;
          webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
        }
      }else if(!request.DeviationNumber){//如果定位成功并且偏差值不存在证明第一次进店，
        if(typeof(request["a_StartPhoto"])=="undefined"){
          webcontext.ResponseMessage.Success =false;
          webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
        }else if(request.a_StartPhoto.toString().trim() == ""){
          webcontext.ResponseMessage.Success =false;
          webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
        }
      }
      //如果门店坐标不存在则上班必须拍照
      if(localStorage.getItem("clock"))
      {
        if(typeof(request["a_StartPhoto"])=="undefined"){
          webcontext.ResponseMessage.Success =false;
          webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
        }else if(request.a_StartPhoto.toString().trim() == ""){
          webcontext.ResponseMessage.Success =false;
          webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
        }
      }
      //表示定位成功但是偏差值大于设定的距离
      if(localStorage.getItem("clockOut")){
        // if(typeof(request["a_StartRemark"])=="undefined"){
        //   webcontext.ResponseMessage.Success =false;
        //   webcontext.ResponseMessage.ErrorMessage ="请填写备注说明";
        // }else if(request.a_StartRemark.toString().trim() == ""){
        //   webcontext.ResponseMessage.Success =false;
        //   webcontext.ResponseMessage.ErrorMessage ="请填写备注说明";
        // }
         if(typeof(request["a_StartPhoto"])=="undefined"){
          webcontext.ResponseMessage.Success =false;
          webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
        }else if(request.a_StartPhoto.toString().trim() == ""){
          webcontext.ResponseMessage.Success =false;
          webcontext.ResponseMessage.ErrorMessage ="必须拍摄门头照";
        }

      }
      if(request.DeviationNumber){
          request.a_InDeviationNumber = request.DeviationNumber;//上班与门店的偏差值
         
        }
        delete request.DeviationNumber;
        const info:any = localStorage.getItem("pginfo");
        const anyinfo = JSON.parse(info)||{};
        if(!anyinfo["a_ID"]){
            webcontext.ResponseMessage.Success =false;
            webcontext.ResponseMessage.ErrorMessage ="数据有误,请重新登录";
        }
        request["a_id"]= anyinfo["a_ID"];//排版ID
        // let oldDate =anyinfo["a_SNStartDate"];
        request["a_SNStartDate"] = anyinfo["a_SNStartDate"];
        // let datepie:DatePipe =new DatePipe("en-US");
        //  let datetime = datepie.transform(new Date(),"yyyy-MM-dd HH:mm:ss");//上班打卡时间
        //     request["a_StartDate"] = datetime;//上班打卡时间
        //     localStorage.setItem("startDate",datetime);
        //     //计算是否早退
        //     // console.log(webcontext.ID);
        //     const info:any = localStorage.getItem("pginfo");
        //     const anyinfo = JSON.parse(info)||{};
        //     request["a_id"]= anyinfo["a_ID"];//排版ID
        //     let oldDate =anyinfo["a_SNStartDate"];//开始日期
        //     var oDate1 = new Date(datetime.replace(/-/g,"/"));//开始日期
        //     if(oldDate!=0){
        //      var oDate2 = new Date(oldDate.replace(/-/g,"/"));//结束日期
        //     if(oDate1.getTime()>oDate2.getTime()){//打卡时间大于上班时间则为迟到
        //      request["a_WorkState"]=2;//表示迟到
        //     }else{
        //      request["a_WorkState"]=1;//表示正常上班打卡
        //       }
        //     }
            // webcontext.ResponseMessage.Success =false;
            // webcontext.ResponseMessage.ErrorMessage ="必须上传照片";
            webcontext.RequestBody = JSON.stringify(request);
            webcontext.SpecialParameter = "clockIn";
    }
    return webcontext;
  }
  public HandleServerContextAfterDBRequest(webParameterContext:WebParameterContext,webContext:WebResponesContext):WebResponesContext {
   const that = this;
   if (webParameterContext.ConfigType.toLowerCase() == "form") {
     if (webContext.ResponseMessage.Success) {
       localStorage.removeItem("clock");
       localStorage.removeItem("clockOut");
       localStorage.setItem("pgindata","true");
       localStorage.removeItem("pgondate");
       const StartDate = webContext.Status["StartDate"] || "";
       const info:any = localStorage.getItem("pginfo");
       const anyinfo = JSON.parse(info)||{};
             anyinfo["a_StartDate"]=StartDate;
             localStorage.setItem("pginfo",JSON.stringify(anyinfo));
            //  localStorage.removeItem("startDate");
     }
   }
    return webContext
  }
  

}